import React from 'react';
import { HeaderType, ThemeType } from '../../models/api/codegen/code';
import { changeHeaderPlayer, getFavoritesCount, getHeader } from '../../spirsApi/api-client';
import { CHANGE_THEME, SET_FAVORITES_COUNT } from '../../store/spirs/actions';
import { useDispatch, useSelector } from 'react-redux';
import { StoreType } from '../../store/spirs/types';
//@ts-ignore
import { Logo } from 'uitabs-components';
import { NavigationTabs, TabMenu } from './NavigationTabs/NavigationTabs';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { StarIcon } from './StarIcon';
import { InfoMenu } from './InfoMenu/Infomenu';
import { ReactComponent as MenuHamburgerButton } from './menu_button.svg';
import { ReactComponent as SearchIconSvg } from './round-search.svg';

type DesktopHeaderProps = {
    toggleVerticalMenu: () => void;
    showLogo: boolean;
};

export const Header = React.memo(
    (props: DesktopHeaderProps) => {
        const { toggleVerticalMenu, showLogo } = props;
        const { t } = useTranslation();
        const location = useLocation();
        const [counter, setCounter] = React.useState<number>(0);
        const [header, setHeader] = React.useState<HeaderType | undefined>(
            undefined
        );
        const [searchOpen, setSearchOpen] = React.useState<boolean>(false);
        const theme = useSelector((store: StoreType) => store.theme);
        const playerToken = useSelector(
            (store: StoreType) => store.spirs.playerToken
        );
        const playerId = useSelector(
            (store: StoreType) => store.spirs.playerInfo.playerId
        );
        const favoritesCount: number = useSelector((state: StoreType) => state.spirs.favoritesCount);
        const dispatch = useDispatch();

        React.useEffect(() => {
            const lsTheme = localStorage.getItem('theme');
            getHeader().then(data => {
                if (!data) {
                    return;
                }
                setHeader(data);
                const newTheme =
                    lsTheme && !data.theme.force ? lsTheme : data.theme.type;
                dispatch(
                    CHANGE_THEME({
                        ...theme,
                        type: newTheme as ThemeType,
                        switchTheme: data.theme.switchTheme
                    })
                );
            });
        }, [playerToken]);


        React.useEffect(() => {
            setCounter(favoritesCount)
        }, [favoritesCount])

        const desktopTabRoutes: string[] = !header
            ? []
            : header.menu.filter(m => m.type === 'route').map(m => m.route);

        const preparedRoutes = desktopTabRoutes.map(item =>
            item !== '/' ? `/sport${item}` : item
        );

        const favoriteCounter = counter === 0 ? '' : ' (' + counter + ')';

        const selectedTab = preparedRoutes.includes(location.pathname)
            ? location.pathname
            : false;

        const StarIconComponent = (
            <span className="mr-[8px]">
                <StarIcon selected={selectedTab === '/sport/favorites'} />
            </span>
        );
        const SearchIcon = (
            <span className="mr-[8px]">
                <SearchIconSvg
                    className="fill-[#C6C7C9]"
                    width={20}
                    height={20}
                />
            </span>
        );

        const deskTopTabs: TabMenu[] = !header
            ? []
            : header.menu.map(m => ({
                  route: `/sport${m.route}`,
                  label: m.translate ? t(m.label) : m.label,
                  counter: m.counter ? favoriteCounter : '',
                  flag: false,
                  state: m.id,
                  type: m.type,
                  icon: m.withIcon
                      ? m.id === 'favorites'
                          ? StarIconComponent
                          : m.id === 'search'
                          ? SearchIcon
                          : undefined
                      : undefined,
                  isMobile:
                      m.id === 'live' ||
                      m.id === 'rating' ||
                      m.id === 'favorites' ||
                      m.id === 'search'
              }));

        const handleSearchToggle = () => {
            setSearchOpen(!searchOpen);
        };

        return (
            <>
                <header
                    className={`sticky ${!showLogo ? 'top-[50px] tablet:top-[68px]' : 'top-0'} bg-[#171A1E] z-[9] flex items-center justify-between px-[16px] tablet:px-[30px]`}
                    id="to-scroll"
                >
                    <div className="flex">
                        <div className="grid max-tablet:grid-cols-[1fr_3fr] notebook:grid-cols-[1fr_3fr]">
                            <div className="tablet:pl-[20px] w-0 notebook:w-[240px] flex items-center gap-[10px]">
                                <div
                                    className="tablet:hidden"
                                    onClick={toggleVerticalMenu}
                                >
                                    <MenuHamburgerButton className="fill-[rgba(0_0_0_0.54)]" />
                                </div>
                            </div>
                            <NavigationTabs
                                desktopTabRoutes={preparedRoutes}
                                menu={deskTopTabs}
                                onSearchToggle={handleSearchToggle}
                            />
                        </div>
                    </div>
                    <InfoMenu />
                </header>

            </>
        );
    },
    (prevProps, nextProps) => true
);
